import { extendTheme } from '@chakra-ui/react';
import {
  primary600,
  primary700,
  neutral0,
  neutral100,
  neutral700,
} from '@hover/tokens-color';
import { size400 } from '@hover/tokens-size';

const Button = {
  baseStyle: {
    height: 'fit-content',
    fontWeight: 'bold',
    bgColor: primary600,
    color: neutral0,
    borderRadius: '100px',
    paddingLeft: size400,
    paddingRight: size400,
    _hover: {
      bgColor: primary700,
    },
  },
  variants: {
    outline: {
      bgColor: neutral0,
      background: neutral0,
      color: primary600,
      borderColor: primary600,
      borderWidth: '2px',
      _hover: {
        bgColor: neutral100,
      },
    },
  },
  defaultProps: {
    // probably set this to an empty string if you're running into issues with the default theme
    colorScheme: '',
  },
};

const Link = {
  variants: {
    blue: {
      color: '#247ddc',
    },
    gray: {
      color: '#a7a7a7',
    },
  },
  defaultProps: { variant: 'blue' },
};

export const legacyTheme = extendTheme({
  colors: {
    hoverBlue: primary600,
    hoverLightBlue: '#5097E3',
  },
  components: {
    Button,
    Link,
  },
  styles: {
    global: {
      h1: {
        color: neutral700,
      },
    },
  },
});
